import { normalizeBrand } from '../../utils';

export function brandFromOrderForm(context: Record<string, any>) {
  if (!context.orderForm && !context.orderForm.items?.length) return null;

  const items = context.orderForm.items;

  return normalizeBrand(items);
}
